import { render, staticRenderFns } from "./BtnBigSquare.vue?vue&type=template&id=6bb14ed4&scoped=true&"
import script from "./BtnBigSquare.vue?vue&type=script&lang=js&"
export * from "./BtnBigSquare.vue?vue&type=script&lang=js&"
import style0 from "./BtnBigSquare.vue?vue&type=style&index=0&id=6bb14ed4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bb14ed4",
  null
  
)

export default component.exports